import { CustomerServiceFilled, DiscountFilled } from '@ixigo/icons';
import Typography from '@ixigo/iui/Typography';
import { FC } from 'react';
import MoreMenu from './MoreMenu';
import UserMenu from './UserMenu';
import { LOGO, MENU_ITEMS, isHeaderNavVisible } from './helper';

const HeaderNavigation: FC = () => (
    <div className='sticky top-0 bg-white shadow-100 z-40'>
        <div className='flex justify-between items-center max-w-desktop-max h-[70px] mx-auto px-30'>
            <div className='flex items-center gap-20'>
                <a href='/'>{LOGO}</a>
                {isHeaderNavVisible && (
                    <>
                        {MENU_ITEMS.map((item) => (
                            <a key={item.label} href={item.href} className='flex items-center gap-5'>
                                <img src={item.img} alt={item.label} width={40} height={40} />
                                <Typography variant='body-md' fontWeight='bold' className='text-charcoal-600'>
                                    {item.label}
                                </Typography>
                            </a>
                        ))}
                        <MoreMenu />
                    </>
                )}
            </div>
            {isHeaderNavVisible && (
                <div className='flex items-center gap-20'>
                    <a href='/offers' className='flex items-center gap-5 text-charcoal-600 hover:text-charcoal-800'>
                        <DiscountFilled />
                        <Typography variant='body-md'>Offers</Typography>
                    </a>
                    <a href='/support' className='flex items-center gap-5 text-primary-500'>
                        <CustomerServiceFilled />
                        <Typography variant='body-md' fontWeight='medium'>
                            Customer Service
                        </Typography>
                    </a>
                    <UserMenu />
                </div>
            )}
        </div>
    </div>
);

export default HeaderNavigation;
